(() => {
  let generation = 0, controller;
  const bound = new WeakSet();
  const isItalian = () => document.documentElement.lang.toLowerCase().startsWith('it');
  let sdkReady = false;
  const pendingHearts = new Map();
  // Queue an early click without opening dialogs or changing privacy preferences.
  document.addEventListener('click', event => {
    const heart = event.target.closest && event.target.closest('button.swym-button');
    if (!heart || sdkReady) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (pendingHearts.has(heart)) return;
    heart.setAttribute('aria-busy', 'true');
    const timer = setTimeout(() => { heart.removeAttribute('aria-busy'); pendingHearts.delete(heart); }, 10000);
    pendingHearts.set(heart, timer);
  }, true);
  function count(value) {
    const bubble = document.querySelector('.wishlist__bubble');
    if (!bubble) return;
    const number = bubble.querySelector('.wishlist__bubble-num');
    if (number) number.textContent = String(Math.max(0, value));
    bubble.classList.toggle('wishlist__bubble--visible', value > 0);
  }
  function message(container, swat, failed) {
    let notice = document.getElementById('grifo-wishlist-status');
    if (!failed) { if (notice) notice.remove(); return; }
    if (!notice) {
      notice = document.createElement('p'); notice.id = 'grifo-wishlist-status'; notice.setAttribute('role', 'status'); container.insertAdjacentElement('afterend', notice);
    }
    notice.textContent = isItalian() ? 'Non è stato possibile caricare alcuni articoli della wishlist. ' : 'Some wishlist items could not be loaded. ';
    const retry = document.createElement('button'); retry.type = 'button'; retry.textContent = isItalian() ? 'Riprova' : 'Try again'; retry.addEventListener('click', () => render(swat)); notice.appendChild(retry);
  }
  async function cardHtml(url, signal) {
    const request = new AbortController(); const abort = () => request.abort();
    signal.addEventListener('abort', abort, { once: true }); if (signal.aborted) abort();
    const timeout = setTimeout(abort, 12000);
    try { const response = await fetch(url, { signal: request.signal }); if (!response.ok) throw new Error('Wishlist card HTTP ' + response.status); return await response.text(); }
    finally { clearTimeout(timeout); signal.removeEventListener('abort', abort); }
  }
  function render(swat) {
    const current = ++generation; if (controller) controller.abort(); controller = new AbortController(); const signal = controller.signal;
    const container = document.getElementById('wishlist-items-container'); const empty = document.getElementById('empty-wishlist');
    const failedRead = () => { if (container && current === generation) { message(container, swat, true); container.removeAttribute('aria-busy'); } };
    if (container) container.setAttribute('aria-busy', 'true');
    try { swat.fetch(async items => {
      if (current !== generation) return;
      if (!Array.isArray(items)) { if (container) { message(container, swat, true); container.removeAttribute('aria-busy'); } return; }
      count(items.length); if (!container) return;
      const cards = new Array(items.length); let next = 0, failed = false;
      async function worker() {
        while (current === generation && next < items.length) {
          const index = next++, item = items[index];
          try {
            const path = new URL(item.du, location.origin).pathname;
            const match = path.match(/\/products\/([^/]+)\/?$/);
            if (!match) throw new Error('Invalid wishlist product URL');
            const root = window.Shopify.routes.root.replace(/\/?$/, '/');
            const url = new URL(root + 'products/' + match[1], location.origin);
            url.searchParams.set('view', 'card'); url.searchParams.set('variant', String(item.epi)); url.searchParams.set('section_id', 'product-section-card');
            const html = await cardHtml(url.href, signal); if (current !== generation) return;
            const card = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section'); if (!card) throw new Error('Missing wishlist card');
            card.querySelectorAll('a').forEach(anchor => {
              const href = anchor.getAttribute('href'); if (!href) return; const target = new URL(href, location.origin);
              if (target.origin !== location.origin || !target.pathname.includes('/products/')) return;
              target.searchParams.set('variant', String(item.epi)); anchor.setAttribute('href', target.pathname + target.search + target.hash);
            });
            if (item.vi) card.querySelectorAll('.product-name h2').forEach(title => { title.appendChild(document.createTextNode(' - ' + item.vi)); });
            cards[index] = card;
          } catch (error) { if (signal.aborted || current !== generation) return; failed = true; }
        }
      }
      try {
        await Promise.all(Array.from({ length: Math.min(4, items.length) }, worker)); if (current !== generation || !container.isConnected) return;
        const fragment = document.createDocumentFragment(); cards.forEach(card => { if (card) fragment.appendChild(card); }); container.replaceChildren(fragment);
        container.hidden = items.length === 0; if (empty) empty.hidden = items.length > 0; message(container, swat, failed);
        if (cards.some(Boolean)) swat.initializeActionButtons('#wishlist-items-container');
      } catch (error) { if (current === generation) message(container, swat, true); }
      finally { if (current === generation) container.removeAttribute('aria-busy'); }
    }, failedRead); } catch (error) { failedRead(); }
  }
  function customer(swat) {
    const event = swat.JSEvents.customerInfoRefreshed;
    swat.evtLayer.addEventListener(event, function () {
      swat.authCheck(function (result) {
        if (result.authn) {
          window.customWishlistG = window.customWishlistG || {};
          window.customWishlistG.customer = window.customWishlistG.customer || {};
          window.customWishlistG.customer.email = result.email;
          if (result.regn.userinfo.fname) window.customWishlistG.customer.firstName = result.regn.userinfo.fname;
          if (result.regn.userinfo.lname) window.customWishlistG.customer.lastName = result.regn.userinfo.lname;
        }
      });
    });
  }
  function init(swat) {
    if (!swat) return;
    sdkReady = true;
    pendingHearts.forEach((timer, heart) => { clearTimeout(timer); heart.removeAttribute("aria-busy"); if (heart.isConnected) heart.click(); });
    pendingHearts.clear();
    const pending = document.getElementById('grifo-wishlist-consent'); if (pending) pending.remove();
    if (!bound.has(swat)) {
      bound.add(swat);
      function changed(delta) {
        const number = document.querySelector('.wishlist__bubble-num'); count((parseInt(number && number.textContent, 10) || 0) + delta);
        if (document.getElementById('wishlist-items-container')) render(swat);
      }
      swat.evtLayer.addEventListener('sw:addedtowishlist', () => changed(1)); swat.evtLayer.addEventListener('sw:removedfromwishlist', () => changed(-1)); customer(swat);
    }
    setTimeout(() => document.querySelectorAll('.swym-button').forEach(button => button.removeAttribute('style')), 500); render(swat);
  }
  window.SwymCallbacks = window.SwymCallbacks || []; window.SwymCallbacks.push(init);
})();
